export default "__VITE_ASSET__cff36668__"